// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as V2$Linear from "./V2.res.js";
import * as V2f$Linear from "./V2f.res.js";

let zero = V2$Linear.fill(0);

function plus(param, param$1) {
  return [
    param[0] + param$1[0] | 0,
    param[1] + param$1[1] | 0
  ];
}

function minus(param, param$1) {
  return [
    param[0] - param$1[0] | 0,
    param[1] - param$1[1] | 0
  ];
}

function scale(vec, factor) {
  return V2$Linear.map(vec, v => v * factor | 0);
}

function dot(param, param$1) {
  return (param[0] * param$1[0] | 0) + (param[1] * param$1[1] | 0) | 0;
}

function quadrance(vec) {
  return dot(vec, vec);
}

function length(vec) {
  return Math.sqrt(dot(vec, vec));
}

function angle(a, b) {
  let af = V2$Linear.map(a, prim => prim);
  let bf = V2$Linear.map(b, prim => prim);
  return V2f$Linear.angle(af, bf);
}

function dirAngle(a, b) {
  let af = V2$Linear.map(a, prim => prim);
  let bf = V2$Linear.map(b, prim => prim);
  return V2f$Linear.dirAngle(af, bf);
}

let jsonCodec = V2$Linear.jsonCodec(Jzon.int);

export {
  zero,
  plus,
  minus,
  scale,
  dot,
  quadrance,
  length,
  angle,
  dirAngle,
  jsonCodec,
}
/* zero Not a pure module */
